var map = {
	"./2025_final/compete-Pre.vue": [
		"f5CY",
		0,
		28
	],
	"./2025_final/index.vue": [
		"I4Go",
		0,
		5
	],
	"./2025_final/login.vue": [
		"pYkS",
		0,
		20
	],
	"./2025_final/signup.vue": [
		"75YN",
		0,
		6
	],
	"./2025_final/userIndex.vue": [
		"mkEJ",
		0,
		2
	],
	"./2025_global/compete-Pre.vue": [
		"LB9l",
		8
	],
	"./2025_global/index.vue": [
		"hPpc",
		0,
		25
	],
	"./2025_global/login.vue": [
		"2uJq",
		0,
		10
	],
	"./2025_global/rank.vue": [
		"eOdM",
		12
	],
	"./2025_global/userIndex.vue": [
		"LYoU",
		0,
		11
	],
	"./2026/compete-Pre.vue": [
		"i+Bo",
		0,
		30
	],
	"./2026/confirmInfomation.vue": [
		"lrly",
		0,
		21
	],
	"./2026/index.vue": [
		"R/Hm",
		0,
		7
	],
	"./2026/login.vue": [
		"1k9y",
		0,
		24
	],
	"./2026/signup.vue": [
		"9yGk",
		0,
		9
	],
	"./2026/userIndex.vue": [
		"97/O",
		0,
		1
	],
	"./israel2026/index.vue": [
		"/+CI",
		0,
		27
	],
	"./israel2026/login.vue": [
		"X9Gc",
		0,
		53
	],
	"./israel2026/main.vue": [
		"bAJH",
		0,
		33
	],
	"./israel2026/signup.vue": [
		"hx/0",
		0,
		52
	],
	"./israel2026/userIndex.vue": [
		"oPFq",
		0,
		17
	],
	"./mgtv/index.vue": [
		"sAtp",
		0,
		31
	],
	"./mgtv/main.vue": [
		"UgKv",
		0,
		51
	],
	"./teacher/compete-Pre.vue": [
		"8YMq",
		0,
		3
	],
	"./teacher/index.vue": [
		"QVfe",
		0,
		13
	],
	"./teacher/login.vue": [
		"MDYz",
		0,
		23
	],
	"./teacher/signup.vue": [
		"u8SZ",
		0,
		26
	],
	"./teacher/user-groups.vue": [
		"qOUf",
		0,
		4
	],
	"./teacher/userIndex.vue": [
		"nwdp",
		0,
		22
	],
	"./template/index.vue": [
		"xniI",
		0,
		50
	],
	"./template/login.vue": [
		"7oy6",
		0,
		49
	],
	"./template/main.vue": [
		"oBn2",
		0,
		32
	],
	"./template/signup.vue": [
		"IvqQ",
		0,
		48
	],
	"./template/userIndex.vue": [
		"mpjO",
		0,
		16
	],
	"./vn/index.vue": [
		"gLqF",
		47
	],
	"./wrc/compete-Pre.vue": [
		"e0sD",
		0,
		46
	],
	"./wrc/index.vue": [
		"Ri6R",
		0,
		45
	],
	"./wrc/template/index.vue": [
		"qhIX",
		0,
		44
	],
	"./wrc/template/login.vue": [
		"riGw",
		0,
		43
	],
	"./wrc/template/main.vue": [
		"t8lS",
		0,
		42
	],
	"./wrc/template/signup.vue": [
		"FAZy",
		0,
		41
	],
	"./wrc/template/userIndex.vue": [
		"Vpdc",
		0,
		40
	],
	"./wrc_learn/compete-Pre.vue": [
		"fkZr",
		0,
		39
	],
	"./wrc_learn/index.vue": [
		"AYWc",
		0,
		34
	],
	"./wrc_learn/login.vue": [
		"vhSN",
		0,
		38
	],
	"./wrc_learn/signup.vue": [
		"RN08",
		0,
		37
	],
	"./wrc_learn/userIndex.vue": [
		"2k8W",
		0,
		19
	],
	"./wrc_malaysia/index.vue": [
		"pi4A",
		0,
		18
	],
	"./wrc_malaysia/main.vue": [
		"LWL3",
		0,
		36
	],
	"./wrc_singapore/index.vue": [
		"hFs4",
		0,
		29
	],
	"./wrc_singapore/main.vue": [
		"S+bj",
		0,
		35
	],
	"./www/index.vue": [
		"o8Ce",
		0,
		15
	],
	"./www/main.vue": [
		"/lEH",
		0,
		14
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "kPVm";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/contest lazy ^\.\/.*\.vue$
// module id = kPVm
// module chunks = 56